<template>
<div class="row">
    <div class="page-title-nav row">
      <div class="col-2 col-lg-3">
        <router-link to="home" class="btn btn-outline-secondary btn-custom btn-back">
          <i class="fa-icon fa-regular fa-arrow-left me-0"></i>
          <span class="d-none d-lg-block ms-2">ย้อนกลับ</span>
        </router-link>

      </div>
      <div class="col-8 col-lg-6">
        <h1 class="page-title">ตั้งค่าบัญชีผู้ใช้</h1>
      </div>
      <div class="col-12 col-lg-3">
        <a href="#" class="btn btn-primary btn-custom d-none"><i
            class="fa-icon fa-regular fa-home"></i><span>button</span></a>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-6 d-grid">
        <router-link :class="getActiveGamelist() + ``" class="btn  btn-custom btn-xl" :to="`/setting/profile`">
          <img src="@/assets/icon/management.png" class="-icon icon_mb_menu_profile" alt=""> &nbsp; บัญชีผู้ใช้
        </router-link>

      </div>
      <div class="col-6 d-grid">
        <router-link :class="getActiveHistory()" class="btn  btn-custom btn-xl" :to="hasBank ? '/member/settings/bank' : '/member/settings/bank/add'">
          <img src="@/assets/icon/bank.png" class="-icon icon_mb_menu_profile" alt="Menu icon promotion">&nbsp; บัญชีธนาคาร
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
export default {
  props: {
  },
  ...mapActions(['getBalanceInfo', 'setLoading']),
  data () {
    return {
      link: window.location.pathname
    }
  },
  methods: {
    isPageActive (pageName) {
      console.log(this.$route.name)
      return (this.$route.name === pageName)
    },
    getActiveHistory () {
      if (this.link === '/member/settings/bank') {
        return 'btn-label-secondary'
      } else {
        return 'btn-outline-secondary'
      }
    },
    getActiveGamelist () {
      if (this.link === '/setting/profile') {
        return 'btn-label-secondary'
      } else {
        return 'btn-outline-secondary'
      }
    }
  },
  computed: {
    ...mapGetters(['getIsVip']),
    ...mapState({
      hasBank: state => state.bankModule.hasBank
    })
  }
}
</script>

<style>
.icon_mb_menu_profile{
  width: 30px;
  height: auto;
}
.btn-outline-custom{
  color: #050505;
    border-color: #444546;
}
.btn-outline-custom:not(:disabled):not(.disabled):active, .btn-outline-custom:not(:disabled):not(.disabled).active, .show > .btn-outline-custom.dropdown-toggle {
  color: #fff;
    background-color: #1e1e1e;
    border-color: #000000;
}
</style>
